export default __webpack_public_path__ + "static/media/Home-foto-header-partners-Tower-viajes-mobile@2x.7222066e.jpg";